
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-hero-blue to-hero-green">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">Pronto para transformar a gestão energética da sua empresa?</h2>
        <p className="text-xl max-w-2xl mx-auto mb-10 text-white/90">
          Junte-se a centenas de empresas que já estão economizando com energia solar e contribuindo para um futuro mais sustentável.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link to="/cadastro" className="inline-block">
            <Button size="lg" className="bg-white text-hero-blue hover:bg-gray-100 text-lg py-6 px-8 rounded-lg shadow-lg w-full sm:w-auto">
              Começar Agora
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
